import { css } from 'styled-components';
import chroma from 'chroma-js';

import { buttonColor, purplebuttonColor, greyButtonColor, greenButtonColor } from 'js/config/style';

const buttonColors = {
  default: buttonColor,
  purple: purplebuttonColor,
  grey: greyButtonColor,
  green: greenButtonColor,
};

function resolveColor(color, defaultColor) {
  if (color) {
    return buttonColors[color] ? buttonColors[color] : color;
  }
  return defaultColor || buttonColors.default;
}

const animatedBackground = css`
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  color: ${({ textColor, color, inverted, isLoading }) =>
    inverted ? (isLoading ? 'white' : resolveColor(color)) : resolveColor(textColor, 'white')} !important;
  background: ${({ color }) => {
    color = chroma(resolveColor(color));
    return `linear-gradient(to right, ${color.brighten(1).hex()} 8%, ${color.hex()} 18%, ${color
      .brighten(1)
      .hex()} 33%)`;
  }};
  background-size: 1000px 104px;
`;

const flatStyle = css`
  border-top-left-radius: 0;
  border-top-right-radius: 0;
`;

const solidBackground = css`
  background: ${({ inverted, color }) => (inverted ? 'transparent' : resolveColor(color))};
`;

const hoverBackground = css`
  color: ${({ textColor, color, inverted }) => (inverted ? resolveColor(color) : resolveColor(textColor, 'white'))};
  background: ${({ inverted, color }) =>
    inverted ? 'transparent' : chroma.mix(chroma(resolveColor(color)), chroma('black'), 0.1)};
`;

const buttonBorder = css`
  border: 1px solid ${({ color }) => resolveColor(color)};
  border-radius: 5px;
`;

const disabledStyle = css`
  && {
    background-color: ${({ color }) => resolveColor(color).brighten()};
    cursor: default;
  }
`;

export const horizontalPadding = 1;
export const verticalPadding = 0.6;
export const lineHeight = 1.8;
export const buttonHeight = verticalPadding * 2 + lineHeight;

export default css`
  && {
    && {
      border: none;
      border-radius: 5px;
      width: 100%;
      max-width: 100%;
      font-weight: normal;
      transition: none;
      line-height: ${lineHeight}rem;
      font-size: 1rem;
      padding: ${verticalPadding}rem ${horizontalPadding}rem;
      white-space: normal;
      cursor: ${props => (props.isLoading || props.wasClicked ? 'default' : 'pointer')};
      color: ${({ textColor, color, inverted }) => (inverted ? resolveColor(color) : resolveColor(textColor, 'white'))};

      &:focus {
        color: ${({ textColor, color, inverted }) =>
          inverted ? resolveColor(color) : resolveColor(textColor, 'white')};
        box-shadow: none;
      }

      &:hover {
        color: ${({ textColor, color, inverted }) =>
          inverted ? resolveColor(color) : resolveColor(textColor, 'white')};
        ${({ isLoading, wasClicked }) => (isLoading || wasClicked ? animatedBackground : hoverBackground)};
      }

      &:active {
        color: ${({ textColor, color, inverted }) =>
          inverted ? resolveColor(color) : resolveColor(textColor, 'white')};
        background: ${({ color, inverted }) => {
          if (!inverted) {
            return chroma.mix(chroma(resolveColor(color)), chroma('black'), 0.2);
          }
          return 'transparent';
        }};
        box-shadow: 0 0px 14px -6px ${({ color }) => resolveColor(color)} inset;
      }

      ${({ disabled }) => disabled && disabledStyle}
      ${({ inverted }) => inverted && buttonBorder};
      ${({ flat }) => flat && flatStyle}
      ${({ isLoading, wasClicked }) => (isLoading || wasClicked ? animatedBackground : solidBackground)};
    }
  }
`;
